module.exports = {
	"LANGUAGE": "Language TR",
	"HDR-obpa_fulltext_score": "Score TR",
	"HDR-obpa_name": "Name TR",
	"HDR-obpa_fulltext_summary": "Summary TR",
	"QUERY LIMIT REACHED": "There are more results than what is displayed. Please narrow your search criteria. TR",
	"NO DOCUMENTS FOUND": "No documents found. TR",
	"OPEN IN NEW WINDOW": "Open in New Window TR",
	"DOWNLOAD NATIVE": "Download in Native Format TR",
	"CLOSE": "Close TR",
	"SEARCH TYPE": "Search Type TR",
	"DOCUMENT TYPE": "Document Type TR",
	"SEARCH TERM": "Search Term TR",
	"SEARCH": "Search TR",
	"RESET": "Reset TR",
	"DATE": "Date TR",
	"FROM DATE": "From Date TR",
	"TO DATE": "To Date TR",
	"LOADING": "Loading... TR",
	"RETRY": "Retry TR",
	"ERROR": "Error! TR",
	"ERROR: QUERIES": "Unable to retrieve the list of search types. TR",
	"ERROR: DOCTYPES": "Unable to retrieve the list of Document Types. TR",
	"ERROR: KEYWORDS": "Unable to retrieve the list of search fields. TR",
	"ERROR: DOCUMENTS": "Unable to perform the requested search. TR",
	"FORM: INVALID FULLTEXT": "Field must be at least {{chars}} characters. TR",
	"FORM: INVALID DATE SHORT": "Format: {{format}} . TR",
	"FORM: REQUIRED KEYWORD": "Field is required. TR",
	"FORM: INVALID NUMERIC": "Field must be a number of up to {{digits}} digits. TR",
	"FORM: INVALID DATE": "Field must follow format {{format}} . TR",
	"FORM: INVALID CURRENCY": "Field must be a valid currency value. TR",
	"FORM: INVALID FLOAT": "Field must be a number. TR",
	"FORM: INVALID LENGTH": "Field must be at most {{chars}} characters. TR",
	"FORM: ERRORS": "There are errors on the form. TR",
	"FORM: noDate": "A date range must be specified. TR",
	"FORM: noKeyword": "At least one field must be specified. TR",
	"FORM: noDateOrKeyword": "A date range OR At least one field must be specified. TR",
	"FORM: noDateAndKeyword": "A date range AND At least one field must be specified. TR"
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/tr.json
// module id = 361
// module chunks = 0